
export default {
  text: 'Parte da família P&G',
  links: [
    {
      link: 'https://br.pg.com/',
      image: {
        resolutions: {
          src: 'https://images.ctfassets.net/bwmjeuu0n1om/3aHO1Tt2aiKo0E6tzehe8l/ea0f69818bb8859a08a104e1002479e6/PnG_logo.png',
        },
        altText: 'P&G',
      },
    },
    {
      link: 'https://www.headandshoulders.com.br/pt-br',
      image: {
        resolutions: {
          src: 'https://images.ctfassets.net/bwmjeuu0n1om/43HxJuGGa4tCr0g9yglRbc/7052024ef472b41a911c245b696d0759/HS.png',
        },
        altText: 'Head&Shoulders',
      },
    },
    {
      link: 'https://herbalessencesbr.com/pt-br/',
      image: {
        resolutions: {
          src: 'https://images.ctfassets.net/bwmjeuu0n1om/2Ns1M7i8p8TwjtP2HsbTbj/31bc90e8c221512951113e8891cc3727/HE.png',
        },
        altText: 'Herbal Essences',
      },
    },
    {
      link: 'https://aussie.com.br/pt-br/',
      image: {
        resolutions: {
          src: 'https://images.ctfassets.net/bwmjeuu0n1om/6b0kun3Z0FX3lobcXUyLIN/8b161efe6dbb032cb30b16014b079b01/Aussie-footer-logo.png',
        },
        altText: 'Logo - Aussie',
      },
    },
  ],
};
